// Validation pattern types
type ValidationPattern = 
  | 'required'
  | 'name'
  | 'nameMaxMin'
  | 'postalcode'
  | 'email'
  | 'phone'
  | 'isAlphaNumeric'
  | 'vin'
  | 'odometer'
  | 'positive';

const formValidationController = (function () {

  const validateName = (n: string): boolean => {
    return /^[^\]+`¬\^\[%\*$|#~=!£{};:,"_=£!~?\/\\[0-9]+$/.test(n);
  };

  const validateEmail = (email: string): boolean => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePostalCode = (postal: string): boolean => {
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(postal);
  };

  // True when US number format ("123 123 1234", "123-123-1234", "+1 123 123 1234", etc).
  const validatePhone = (phone: string): boolean => {
    return /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(phone);
  };

  const isAlphaNumeric = (str: string): boolean => {
    let code: number, i: number, len: number;

    for (i = 0, len = str.length; i < len; i++) {
      code = str.charCodeAt(i);
      if (!(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123)) { // lower alpha (a-z)
        return false;
      }
    }
    return true;
  };

  const validateVIN = (vin: string): boolean => {
    return (vin.length === 17);
  };

  return {
    validateField: function (value: string | number | boolean, pattern: ValidationPattern): boolean {
      switch (pattern) {
        // Check field has a value
        case 'required':
          const requiredFulfilled = typeof value === 'string' 
            ? value.length > 0 
            : value === true;
          return requiredFulfilled;
        // Check name format
        case 'name':
          return validateName(String(value));
        // Check length
        case 'nameMaxMin':
          return (String(value).length >= 2 && String(value).length <= 50);
        // Check postal code
        case 'postalcode':
          return validatePostalCode(String(value));
        // Check email format
        case 'email':
          return validateEmail(String(value));
        // Check phone format
        case 'phone':
          return validatePhone(String(value));
        // Check alpha/numeric
        case 'isAlphaNumeric':
          return isAlphaNumeric(String(value));
        // Check VIN length
        case 'vin':
          return validateVIN(String(value));
        // Check Odometer is Number
        case 'odometer':
          return !isNaN(Number(value));
        // Check positive/negative
        case 'positive':
          return (Number(value) >= 0);
        default:
          return false;
      }
    },
  };
})();

export default formValidationController;
